import { useParams } from 'react-router';
import { ProjectConversationId, ProjectId } from 'api/models';
import { ProjectDetailTabKeys } from 'api/project';
import {
  getProjectConversationDetailUrl,
  getProjectConversationPageUrl,
  getProjectFilesUrl,
  getProjectFormResponsesUrl,
  getProjectOverviewUrl,
  getProjectPlanUrl,
  getProjectSpacesUrl,
  getProjectStatusUpdatesDetailUrl,
  getProjectStatusUpdatesUrl,
  getProjectTaskBoardUrl,
  getProjectTaskListUrl,
  getProjectFinancialsUrl,
} from 'utils/urls';

export const useTabActions = (projectId: ProjectId) => {
  const urlParams = useParams();

  const getStatusUpdateKey = () => {
    const { statusUpdateId } = urlParams as { statusUpdateId?: string };

    return statusUpdateId
      ? getProjectStatusUpdatesDetailUrl(projectId[1], statusUpdateId)
      : getProjectStatusUpdatesUrl(projectId);
  };

  const getProjectChatKey = () => {
    const { chatId: _chatId } = urlParams as { chatId: string };

    const chatId = Number(_chatId);

    return chatId
      ? getProjectConversationDetailUrl(
          projectId,
          ProjectConversationId(Number(chatId)),
        )
      : getProjectConversationPageUrl(projectId);
  };

  const getPathName = (key: ProjectDetailTabKeys) => {
    switch (key) {
      case ProjectDetailTabKeys.Overview: {
        return getProjectOverviewUrl(projectId);
      }
      case ProjectDetailTabKeys.Financials: {
        return getProjectFinancialsUrl(projectId);
      }
      case ProjectDetailTabKeys.Plan: {
        return getProjectPlanUrl(projectId);
      }
      case ProjectDetailTabKeys.Spaces: {
        return getProjectSpacesUrl(projectId);
      }
      case ProjectDetailTabKeys.Chat: {
        return getProjectChatKey();
      }
      case ProjectDetailTabKeys.TaskList: {
        return getProjectTaskListUrl(projectId);
      }
      case ProjectDetailTabKeys.TaskBoard: {
        return getProjectTaskBoardUrl(projectId);
      }
      case ProjectDetailTabKeys.StatusUpdate: {
        return getStatusUpdateKey();
      }
      case ProjectDetailTabKeys.FormResponses: {
        return getProjectFormResponsesUrl(projectId);
      }
      case ProjectDetailTabKeys.Files: {
        return getProjectFilesUrl(projectId);
      }
      default: {
        return getProjectOverviewUrl(projectId);
      }
    }
  };

  return {
    getPathName,
  };
};
